import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu_icon",
  "use": "icon-menu_icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu_icon\"><g id=\"icon-menu_icon_æ±å ¡icon\"><g id=\"icon-menu_icon_Vector\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.1875 3.4375H2.8125V5.3125H17.1875V3.4375Z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.1875 9.0625H2.8125V10.9375H17.1875V9.0625Z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.1875 14.6875H2.8125V16.5625H17.1875V14.6875Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol